import React, { FC, ReactElement, useEffect, useState } from 'react';
import cns from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { store } from 'src/stores/store';
import Icon from '../../Icon';
import './StaticPage.sass';
import { getEventKey } from '../../../stores/reducers/userData';
import { getNewsPageContent } from '../../../api';
import localeFieldResolver from '../../../helpers/locale-field-finder';
import { internalizationState } from '../../../stores/reducers/sections';

export interface Props {
  className?: string;
  bgSettings?: {
    color?: string;
    isDark?: boolean;
  };
  newsId?: string;
}

const StaticPage: FC<Props> = ({ className, bgSettings, newsId }): ReactElement => {
  const eventKey = useSelector(getEventKey);
  const [newsContent, setNewsContent] = useState<any>('');
  const [headerImage, setHeaderImage] = useState<string>('');
  const [isExhibition, setExhibition] = useState<boolean>(false);
  const exhibitionHandler = (v: boolean) => setExhibition(v);

  const history = useHistory();
  const { pathname } = useLocation();

  const id = pathname.replace('/static/', '');
  const { activeLangState } = useSelector(internalizationState);

  /* check if current url is inside exhibition section */
  useEffect(() => {
    const { userData } = store.getState();
    const { exhibitionPages } = userData.contentPages;

    const arrayOfUrls: string[] = [];
    const populateArray = (array: string[]) => {
      if (exhibitionPages) exhibitionPages.map((el) => array.push(el.id));

      return array;
    };
    const withData = populateArray(arrayOfUrls).filter(Boolean);
    const compareUrls = (arr: string[], query: string) => arr.filter((name) => name.includes(query));

    exhibitionHandler(!!compareUrls(withData, id).length);
  }, [pathname, id]);

  useEffect(() => {
    // pageData заменен на newsContent. Почему была pageData? Неизвестно. Оставлю этт коммент тут.
    // console.log(pageData);
    
    setHeaderImage(newsContent.image ? newsContent.image : '');
    window.dispatchEvent((window as any).staticPageOpen);
    getNewsPageContent(eventKey, newsId).then((response: any) => {
      setNewsContent(response);
    });
  }, [eventKey, newsId, newsContent.image]);  

  return (
    <section
      className={cns(
        'static-page-section',
        // bgSettings && bgSettings.isDark && 'inner-section--dark-bg',
        className
      )}
      style={{ backgroundColor: bgSettings?.color }}>
      {newsContent && newsContent.title && (
        <div
          className="inner-section__head"
          style={{ backgroundImage: `url(${headerImage})` }}>
          <h1>{ localeFieldResolver(newsContent, 'title', activeLangState) }</h1>
        </div>
      )}
      {!isExhibition && <div style={{ padding: '14px 0' }} />}
      {isExhibition && (
        <div className="header-buttons">
          <div className="container-back">
            <Icon name="ch-arr-left" />
            <button type="button" onClick={() => history.go(-1)}>
            { activeLangState === 'ru' ? 'Назад' : 'Back' }
            </button>
          </div>
          <h1>{ localeFieldResolver(newsContent, 'title', activeLangState) }</h1>
        </div>
      )}
      <div className="container container-static-page">
        {newsContent && newsContent.title && <h4>{ localeFieldResolver(newsContent, 'title', activeLangState) }</h4>}
        {/* <div className="container-tags">
          <span className="tag bgc-pink">{ activeLangState === 'ru' ? 'Финтех' : 'Fintech' }</span>
          <span className="tag bgc-extra">{ activeLangState === 'ru' ? 'Новости' : 'News' }</span>
        </div> */}
        <div className="ui-separator"></div>
        {ReactHtmlParser( localeFieldResolver(newsContent, 'content', activeLangState) )}
      </div>
    </section>
  );
};

export default StaticPage;
